"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseUri = require("../Support/BaseUri");
var _q = require("../Support/Query");
function room(roomId, pixels) {
    return BaseUri.compose()
        .segment(['rooms', "" + roomId, 'thumbnail'])
        .query(_q.parseArg('pixels', pixels))
        .toString();
}
exports.room = room;
function design(designCode, pixels) {
    return BaseUri.compose()
        .segment(['designs', designCode, 'thumbnail'])
        .query(_q.parseArg('pixels', pixels))
        .toString();
}
exports.design = design;
function colorway(designCode, colorCode, pixels) {
    return BaseUri.compose()
        .segment(['designs', designCode, 'colors', colorCode, 'thumbnail'])
        .query(_q.parseArg('pixels', pixels))
        .toString();
}
exports.colorway = colorway;
function rug(args) {
    return BaseUri.compose().segment(['rug', 'preview'])
        .query(_q.rug(args))
        .toString();
}
exports.rug = rug;
function yarn(yarnCode, designCode, refLib, pixels) {
    return BaseUri.compose()
        .segment(['yarns', 'thumbnail'])
        .query(__assign({ code: yarnCode }, _q.parseArg('designCode', designCode), _q.parseArg('refLib', refLib), _q.parseArg('pixels', pixels)))
        .toString();
}
exports.yarn = yarn;
function texture(textureId, pixels) {
    return BaseUri.compose()
        .segment(['textures', "" + textureId, 'thumbnail'])
        .query(_q.parseArg('pixels', pixels))
        .toString();
}
exports.texture = texture;
function trykProduct(productId) {
    return BaseUri.compose()
        .segment(['tryk', 'products', "" + productId, 'thumbnail'])
        .toString();
}
exports.trykProduct = trykProduct;
